import range from 'lodash/range';

export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER';
export const UPDATE_PAGES_RESULT = 'UPDATE_PAGES_RESULT';
export const RESET_INFINITE = 'RESET_INFINITE';
export const RESET_AND_SAVE_INFINITE = 'RESET_AND_SAVE_INFINITE';
export const RESTORE_INFINITE = 'RESTORE_INFINITE';

export const LOADING_BEHAVIOR = {
	PREPEND: 'PREPEND',
	APPEND: 'APPEND',
	REFRESH: 'REFRESH',
	NONE: 'NONE'
};

export function getLoadingBehavior( getState, id, type, page, forceRefresh = false ) {
	let result;
	const state = getState().infiniteScroll;

	if(
		state.earliestLoadedPage === null
		|| state.latestLoadedPage === null
		|| type !== state.loadType
		|| id !== state.id
		|| forceRefresh
	) {
		// This is the initial load
		result = LOADING_BEHAVIOR.REFRESH;
	} else {
		if( page === state.earliestLoadedPage - 1 ) {
			// Scrolling up
			result = LOADING_BEHAVIOR.PREPEND;
		} else if( page === state.latestLoadedPage + 1 ) {
			// Scrolling down
			result = LOADING_BEHAVIOR.APPEND;
		} else if( state.earliestLoadedPage <= page && state.latestLoadedPage >= page ) {
			// Scrolling to edges
			result = LOADING_BEHAVIOR.NONE;
		} else {
			// Jumped to a page
			result = LOADING_BEHAVIOR.REFRESH;
		}
	}

	return result;
}

export function fetchSuccess( id, type, page, totalPages, loadingBehavior ) {
	return {
		type: FETCH_SUCCESS,
		id: id,
		loadType: type,
		page: parseInt( page ),
		totalPages: parseInt( totalPages ),
		loadingBehavior: loadingBehavior
	}
}

export function resetInfinite(){
	return {
		type: RESET_INFINITE
	}
}

export function updatePagesResult( newPage = 1 ) {
	return {
		type: UPDATE_PAGES_RESULT,
		page: parseInt( newPage )
	}
}

export const FRAME_SIZE = 1;

export function filterPageResult( currentPage, earliestLoadedPage, latestLoadedPage ) {
	let payload = range( earliestLoadedPage, latestLoadedPage + 1 );
	if( payload.length > 2 ) {
		let index = payload.indexOf( currentPage );
		if( index === 0 ) {
			return payload.slice( index, index + FRAME_SIZE + 2 )
		} else {
			return payload.slice( index - FRAME_SIZE, index + FRAME_SIZE + 1 )
		}
	} else {
		return payload
	}
}

export function shouldNotUpdateState(getState, request) {
	const state = getState().infiniteScroll,
		page = request.page || 1;

	return (
		!request.forceRefresh &&
		parseInt( state.earliestLoadedPage ) !== parseInt( state.latestLoadedPage ) &&
		parseInt( page ) >= parseInt( state.earliestLoadedPage ) &&
		parseInt( page ) <= parseInt( state.latestLoadedPage ) &&
		!request.postid
	);
}

export const resetAndSaveInfinite = () => {
	return {
		type: RESET_AND_SAVE_INFINITE
	}
};

export const restoreInfinite = () => {
	return {
		type: RESTORE_INFINITE
	}
};


// WEBPACK FOOTER //
// ./common/actions/InfiniteScrollActions.js